import(/* webpackMode: "eager" */ "/frontend/app/page.tsx");
